<template>
  <a-modal
    title="可选方案"
    class="dialog-body"
    width="60%"
    @ok="handleOk"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :keyboard="false"
    :maskClosable="false"
  >
    <div>
      <a-table      
      :loading="confirmLoading"
      :columns="columns"
      :dataSource="schemeList"
      rowKey="id"
      :rowSelection="rowSelection"
      >
      </a-table>
    </div>
    <pdf-preview ref="pdfPreview"></pdf-preview>    
  </a-modal>
</template>

<script>
  import { deleteAction, getAction, postAction } from '@/api/manage'
  import { download } from "@/utils/util"
  import PdfPreview from '@views/apppad/PdfPreview.vue'
  import {downFile, getFileAccessHttpUrl} from "@api/manage"
  export default {
    name: 'SchemeModel',
    components: { PdfPreview },
    props:{

    },
    data(){
      return {
        schemeList:[],
        visible:false,
        confirmLoading:false,
        projectId: '',
        columns: [
              {
                title: '方案名称',
                align: "center",
                fixed:'left',
                dataIndex: 'schemeName',
                width: 200,
              },
              {
                title: '方案备注',
                align: "center",
                fixed:'left',
                dataIndex: 'remark',
              },
              {
              title: '操作',
              align: "center",
              fixed:'right',
              dataIndex: 'action',
              width: 100,
              customRender: (value, row, index) => {
                const child = this.$createElement('a', {
                  domProps: {
                    innerHTML: '预览'
                  },
                  on: {
                    click: ()=> {
                      this.viewScheme(row)
                    }
                  }
                })
                const obj = {
                  children: child,
                  attrs: {},
                };
                return obj;
              },
            }
        ],
        selectedRowKeys: [],
      }
    },
    watch:{

    },
    mounted(){
      
    },
    computed: {
      rowSelection() {
        return {
          type: 'radio', // 显示单选按钮（Ant Design Vue 2.x+ 支持）
          selectedRowKeys: this.selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            // 始终只保留最后一个选中的（实现单选）
            const key = selectedRowKeys[selectedRowKeys.length - 1] || [];
            this.selectedRowKeys = key ? [key] : [];
            
            // 可选：触发选中回调
            // this.onRowSelected(selectedRows[0]);
          },
        };
      },
    },
    methods:{
      initData(id){
        this.projectId = id
        getAction('/tempconfig/tempConfigProject/getOneSchemeById',{id: id}).then(res=>{
          if(res.success){
            this.schemeList = res.result
            this.visible = true
          }else{
            this.$message.error(res.message)
          }
        })
      },
      viewScheme(row){ 
        const that = this;
        that.confirmLoading = true;
        getAction('/scheme/view', { schemeId: row.id }).then(res => {
        if (res.success) {
          const previewUrl = window._CONFIG['staticDomainURL'] + "/" + res.result;
          console.log(previewUrl);

          // download(previewUrl, row.schemeName + '.pdf');
          let url = getFileAccessHttpUrl(previewUrl)
          this.$refs.pdfPreview.openPdf(url)
        } else {
          this.$message.error(res.message)
        }
      }).finally(()=>{
        that.confirmLoading = false;
      })
      },
      handleCancel(){
        this.visible = false
      },
      handleOk(){
        console.log('handleOk')
        if(!this.selectedRowKeys || this.selectedRowKeys.length==0){
          this.$message.error("请选择一个方案！")
          return;
        }
        var that = this
        this.$confirm({
          title: '提示',
          content: '您确定要一键生成该方案？',
          centered: false,
          onOk: () => {
            that.confirmLoading = true;
            postAction('/tempconfig/tempConfigProject/oneGen?id='+ that.projectId +'&schemeId='+ that.selectedRowKeys[0]).then((res) => {
              if (res.success) {
                that.$message.success('一键生成方案成功！');

                // 直接进入最后一页
                that.$emit('gotoPageClick', 8);
                // 关闭弹窗
                that.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },     
      
    }
  }
</script>

<style scoped lang="less">
  .dialog-body{
    /deep/ .ant-modal-content{
      border-radius: 24px;
      //background-image: url(~@/assets/modal-bg.png);
      // background-color: #252626;
      //background-repeat: no-repeat;
      // background-color: gray;
    }
    /deep/ .ant-modal-close-icon{
      // color: white;
    }

    /deep/ .ant-modal-footer{
      text-align: center;
      padding: 20px 0;
    }

    .has-error .ant-input, .has-error .ant-input:hover{
      // background: rgba(255, 255, 255, 0.15);
    }

    /deep/ .ant-form-item{
      margin-bottom: 10px;
      padding-bottom: 0;
    }
  }
  .label{
    /deep/ .ant-form-item-required{
      // color:white;
    }
    /deep/ label{
      // color:white;
    }
  }
  
  .title{
    text-align: center;
    font-size: 16px;
    // color: white;
  }
  .input{
    width: 100%;
    // color:white;
    height: 54px;
    // border: 0;
    border-radius: 12px;
    // background: rgba(255,255,255,0.15);
    background-color: #F2F2F2;
  }

  .input-num {
    width: 100%;
    height: 54px;
    // color:white;
      // border: 0;
      border-radius: 12px;
      // background: rgba(255,255,255,0.15);
      background-color: #F2F2F2;
    /deep/ .ant-input-number-input-wrap{
      height: 100%;
      input{
        height: 100%;
      }
    }
  }

  .date {
    color:orange;
     /deep/ input {
      // color:white;
      height: 54px;
      // border: 0;
      border-radius: 12px;
      // background: rgba(255,255,255,0.15);
      background-color: #F2F2F2;
    }
  }

  .search-input{
    border-radius: 12px;
    // background: rgba(255,255,255,0.15);
    background-color: #F2F2F2;
    /deep/ input {
      // color:white;
      height: 54px;
      // border: 0;
      // background: transparent !important;
    }
  }



  .select{
    height: 54px;
    /deep/ .ant-select-selection{
      // border: 0;
      border-radius: 12px;
      // background: transparent;
      // background: rgba(255,255,255,0.15);
      background-color: #F2F2F2;
    }
    /deep/ ul li{
      height: 46px;
      line-height: 46px;
    }
  }

  .switch{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .textarea{
    width: 100%;
    // border: 0;
    // color:white;
    border-radius: 12px;
    // background: rgba(255,255,255,0.15);
    background-color: #F2F2F2;
  }
</style>